var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: _vm.badgeClasses }, [
    _vm.$slots["left-icon"]
      ? _c(
          "span",
          { staticClass: "badge-icon badge-icon-left" },
          [_vm._t("left-icon")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots.default
      ? _c("div", { staticClass: "badge-content" }, [_vm._t("default")], 2)
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots["right-icon"]
      ? _c(
          "span",
          { staticClass: "badge-icon badge-icon-right" },
          [_vm._t("right-icon")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }